const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	FormTokenField,
	Placeholder,
	PanelBody,
	PanelRow,
	Disabled,
	TextControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
const { withSelect } = wp.data;
const { createElement: el } = wp.element;
import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
 registerBlockType("wp-apidae/entities-list", {
	title: __("Liste de fiche", "wp-apidae"), // Block title.
	description: __("Affiche une sélection manuelle de fiches.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.entitiesList
	},
	supports: {
    align: true,
  },
	attributes: {
		ids: {
      type: "array",
      default: [],
    },
		columns: {
			type: "number",
			default: 2,
		},
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			const postFilter = withSelect((select) => {
				const { isResolving } = select('core/data');
				const { getEntityRecords } = select('core');
				const postTypeSlugs = ['ad_activite','ad_commerce_et_servi','ad_degustation','ad_patrimoine_cultur','ad_patrimoine_nature','ad_fete_et_manifesta','ad_hebergement_colle','ad_hebergement_locat','ad_hotellerie','ad_hotellerie_plein_','ad_domaine_skiable','ad_equipement','ad_sejour_package','ad_restauration'];
				const postList = [];
				postTypeSlugs.forEach((postType) => {
					const args = ['postType', postType, {per_page: -1}];
		
					if (!isResolving('core', 'getEntityRecords', args)) {
							const result = getEntityRecords('postType', postType, {per_page: -1});
		
							if (result !== null ) {
								result.forEach( ( res ) =>{
									postList.push(res);
								})
							}
					}
			});
				return {
					posts: postList,
				};
			})((props) => {
					let postsNames = [];
					let postsFieldValue = [];
	
					postsNames = props.posts.map( (post) => post.title.raw );
					postsFieldValue =  attributes.ids.map( ( postID ) => {
						let wantedPost = props.posts.find( ( post ) => {
							return post.meta.apidae_id === postID;
						} );
						if ( wantedPost === undefined || ! wantedPost ) {
							return false;
						}
						return wantedPost.title.raw;
					} );
					return (
						<FormTokenField
							value={postsFieldValue}
							suggestions={postsNames}
							onChange={ ( ids ) => {
								let selectedPostsArray = [];
								ids.map(
									( postName ) => {
										const matchingPost = props.posts.find( ( post ) => {
											return post.title.raw === postName;
										} );
										if ( matchingPost !== undefined ) {
											selectedPostsArray.push( matchingPost.meta.apidae_id )
										}
									}
								)
								this.props.setAttributes( { ids: selectedPostsArray } );
							} }
							placeholder={__("Ajouter une fiche", "wp-apidae")}
							label={__(
								"Fiches Apidae",
								"wp-apidae"
							)}
						/>
					);
			});

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("General")}>
						<PanelRow>
						{el(postFilter)}
						</PanelRow>
						<TextControl
								type="number"
								label={__("Nombre de colonnes")}
								value={attributes.columns}
								min={`1`}
								max={`5`}
								onChange={(newValue) => {
									props.setAttributes({ columns: Number(newValue) });
								}}
							/>
						</PanelBody>
					</InspectorControls>,
					<>
					{ 0 === attributes.ids.length &&
						<Placeholder
            icon={icons.base}
            label={__("Ajouter une fiche", "wp-apidae")}
          >
            {el(postFilter)}
          </Placeholder>
					}
					{ 0 !== attributes.ids.length &&
						<Disabled>
						<ServerSideRender
							block="wp-apidae/entities-list"
							attributes={attributes}
							/>
					</Disabled>
					}
					</>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
